
<div class="search-input">
	<input #sInput type="text" class="form-control" placeholder="Enter your search">
	<i [class]="doSearchIcon" (click)="doSearch()"></i>
</div>


